import { Component, input } from '@angular/core';
import { type FormControl, type FormGroup, ReactiveFormsModule } from '@angular/forms';

import type { RespondFormWrapperConfig } from '@core/ask-hr-dynamic-forms-types';
import { ScheduleDatePickerComponent } from '@core/interview-find-time-ui';

import { RespondFormWrapperComponent } from '../../partials/respond-form-wrapper/respond-form-wrapper.component';

export interface RespondDateConfig extends RespondFormWrapperConfig {
  placeholder: string;
}

@Component({
  selector: 'input-date-respond',
  imports: [RespondFormWrapperComponent, ReactiveFormsModule, ScheduleDatePickerComponent],
  template: `
    <respond-form-wrapper [answerConfig]="respondConfig()">
      <rt-schedule-date-picker
        [formControl]="respondForm().controls.value"
        [date]="respondForm().value.value ?? ''"
        [placeholder]="respondConfig().placeholder"
        [fullWidth]="true"
        [showClear]="!!respondForm().controls.value.value"
        [useYearNav]="true"
        [disabled]="!!respondConfig().disabled"
        [disableInvalidStyles]="
          !!respondConfig().disabled || respondForm().controls.value.untouched
        "
        leftIcon="calendar-today"
        direction="any"
      />
    </respond-form-wrapper>
  `,
})
export class RespondDateComponent {
  public respondConfig = input.required<RespondDateConfig>();
  public respondForm = input.required<
    FormGroup<{
      value: FormControl<string>;
    }>
  >();
}
